import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button2, Dialog2 } from '@dossierhq/design';
import { useCallback, useContext, useState } from 'react';
import { EntityDisplayDispatchContext } from '../../contexts/EntityDisplayDispatchContext.js';
import { EntityDisplayActions } from '../../reducers/EntityDisplayReducer/EntityDisplayReducer.js';
import { PublishedLocationDisplayDialog } from '../PublishedLocationDisplayDialog/PublishedLocationDisplayDialog.js';
export function LocationFieldDisplay({ value }) {
    const [showSelector, setShowSelector] = useState(false);
    const handleShowSelector = useCallback(() => setShowSelector(true), [setShowSelector]);
    const dispatchEntityDisplayState = useContext(EntityDisplayDispatchContext);
    const handleEntityClick = useCallback((entity) => {
        dispatchEntityDisplayState(new EntityDisplayActions.AddEntity(entity.id));
    }, [dispatchEntityDisplayState]);
    return value ? (_jsxs(Dialog2.Trigger, { isOpen: showSelector, onOpenChange: setShowSelector, children: [_jsxs(Button2, { onClick: handleShowSelector, iconLeft: "location", children: [value.lat, ", ", value.lng] }), _jsx(PublishedLocationDisplayDialog, { title: "Location", value: value, onEntityClick: handleEntityClick })] })) : null;
}
//# sourceMappingURL=LocationFieldDisplay.js.map